'use client';

import { Contact } from '@/components/contact';
import { ExamplesBlock } from '@/features/process/blocks/examples/examples-block';
import { HeroBlock } from '@/features/process/blocks/hero/hero-block';
import { ProcessBlock } from '@/features/process/blocks/process/process-block';
import { processConfig } from '@/features/process/process.config';
import { MainLayout } from '@/layouts/main';
import { useT } from 'next-i18next/client';
import Head from 'next/head';
import { generateNextSeo } from 'next-seo/pages';
import type { FC } from 'react';

export const ProcessPage: FC = () => {
  const { t } = useT(processConfig.i18nNamespaces);

  return (
    <>
      <Head>{generateNextSeo({
        title: t('process:page.title'),
        description: t('process:page.description')
      })}</Head>
      <MainLayout>
        <div className="bg-[#0A0A0A] relative">
          <HeroBlock />
          <ProcessBlock />
          <ExamplesBlock />
          <Contact />
        </div>
      </MainLayout>
    </>
  );
};
